import { ColDef } from "ag-grid-community";

const columnDef: ColDef[] = [
    {
        headerName: "ID",
        field: "id",
        sortable: true,
        filter: true,
        resizable: true,
        width: 150,
        headerStyle: { paddingLeft: "24px" },
        cellStyle: { paddingLeft: "24px" },
    },
    {
        headerName: "Team Name",
        field: "name",
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
    },
    {
        headerName: "Members",
        field: "members",
        sortable: true,
        resizable: true,
        width: 120,
    },
    {
        headerName: "Description",
        field: "description",
        sortable: true,
        resizable: true,
        flex: 2,
    },
    {
        headerName: "Created At",
        field: "createdAt",
        sortable: true,
        resizable: true,
        flex: 1,
    },
];

export { columnDef };
